export const PROFILE_CONTACTS_WIDGET_DELETE_NOTIFICATION_ID = 'delete_value'

export const PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY = {
  cannotDeleteValue: 'ProfileContactsWidget.CannotDeleteNotificationKey',
  copied: 'ProfileContactsWidget.CopiedNotificationKey',
  deleted: 'ProfileContactsWidget.ModalDeletedNotificationKey',
  deleteValue: 'ProfileContactsWidget.DeleteNotificationKey',
  saved: 'ProfileContactsWidget.SavedNotificationKey',
}

export const PROFILE_CONTACTS_WIDGET_VALUE_FIELD = 'value'
